import { render } from "./AdminNav.vue?vue&type=template&id=7be08d84&scoped=true"
import script from "./AdminNav.vue?vue&type=script&lang=js"
export * from "./AdminNav.vue?vue&type=script&lang=js"

import "./AdminNav.vue?vue&type=style&index=0&id=7be08d84&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7be08d84"
/* hot reload */
if (module.hot) {
  script.__hmrId = "7be08d84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7be08d84', script)) {
    api.reload('7be08d84', script)
  }
  
  module.hot.accept("./AdminNav.vue?vue&type=template&id=7be08d84&scoped=true", () => {
    api.rerender('7be08d84', render)
  })

}

script.__file = "src/components/AdminNav.vue"

export default script